import { useState } from 'react';

// styles
import './MegaMenu.scss';

// components
import ExpertiseLayout from './expertise-layout/ExpertiseLayout';
import SoftwareLayout from './software-layout/SoftwareLayout';
import MenuHeader from './menu-header/MenuHeader';
import IndustriesLayout from './industries-layout/IndustriesLayout';
import ResourcesLayout from './resources-layout/ResourcesLayout';
import LocationsLayout from './locations-layout/LocationsLayout';

export default function MegaMenu({
  menuData,
  handleMenuEnter,
  handleMenuLeave,
  idx,
}) {
  const [open, setOpen] = useState(false);

  const menuTitle = menuData?.content?.title;
  const menuDesc = menuData?.content?.description;

  const isExpertise = Array.isArray(menuData?.content?.divisions);
  const isIndustries = Array.isArray(menuData?.content?.categories);
  const isSoftware = Array.isArray(menuData?.content?.sections);
  const isResources = Array.isArray(menuData?.content?.resource_types);
  const isLocations = Array.isArray(menuData?.content?.regions);

  const divisions = isExpertise ? menuData.content.divisions : [];
  const categories = isIndustries ? menuData.content.categories : [];
  const sections = isSoftware ? menuData.content.sections : [];

  return (
    <nav
      className="menu-container"
      onMouseEnter={(e) => {
        setOpen(true);
        handleMenuEnter?.(e, idx);
      }}
      onMouseLeave={() => {
          setOpen(false);
          handleMenuLeave?.();
      }}>
      <a className="menu-trigger" href={menuData.href}>
        {menuData?.title}
      </a>

      {open && (
        <div
          className={
            isResources
              ? 'mega-menu resources-layout-megamenu'
              : isIndustries
              ? 'mega-menu industries-mega-menu'
              : 'mega-menu'
          }
        >
          {!isResources ? (
            <MenuHeader title={menuTitle} description={menuDesc} />
          ) : (
            ''
          )}

          {isExpertise && <ExpertiseLayout divisions={divisions} />}
          {isIndustries && (
            <IndustriesLayout
              categories={categories}
              link={menuData.href}
              content={menuData.content}
            />
          )}
          {isSoftware && (
            <SoftwareLayout
              sections={sections}
              viewAll={menuData.content.view_all}
            />
          )}
          {isResources && (
            <ResourcesLayout
              title={menuTitle}
              resource_types={menuData.content.resource_types}
              view_all={menuData.content.view_all}
              featured_content={
                Array.isArray(menuData.content.featured_content)
                  ? menuData.content.featured_content
                  : menuData.content.featured_content
                  ? [menuData.content.featured_content]
                  : []
              }
            />
          )}
          {isLocations && (
            <LocationsLayout
              regions={menuData.content.regions}
              viewAll={menuData.content.view_all}
              link={menuData.href}
            />
          )}
        </div>
      )}
    </nav>
  );
}
